<div class='wrapperProgressBar'>
  <!--mode="determinate"-->
  <mat-progress-bar class='color-{{color}} bcg-{{bcg}}' [value]='value' [ngStyle]='{height: height+"px"}'></mat-progress-bar>
  <div *ngIf='showPercent' class='wrapperProgressBar__percent'>{{value}}%</div>
</div>

